<template lang="pug">
.page.is-form.with-cover.page__light.register
  bokeh-backdrop.page__backdrop
  .page__form.inner-gap
    h1.page__title Register
    .page__description
      span.mr-2 Already have an account?
      nuxt-link.linked(
        :to="{ name: 'login' }"
        title="Login") Login

    request-access-form
</template>

<script>
import BokehBackdrop from '~/components/home/BokehBackdrop'
import RequestAccessForm from '~/components/monday/RequestAccessForm'

export default {
  components: {
    BokehBackdrop,
    RequestAccessForm
  },

  layout: 'static',

  head () {
    return {
      title: 'Request Access'
    }
  }
}
</script>
